module.exports = __webpack_public_path__ + "img/3_109.d9c0ff1f.png";